import { useQuery } from "@tanstack/react-query";
import { getMySubscription } from "../api";

export const MY_SUBSCRIPTION_KEY = ["subscription", "me"] as const;

export function useMySubscription() {
  return useQuery({
    queryKey: MY_SUBSCRIPTION_KEY,
    queryFn: getMySubscription,
    staleTime: 60_000,
  });
}
